import { SaleOfferDepartureSerialNumber } from './sale-offer-departure-serial-number';

export class SaleOfferDeparture {
  constructor(
    public hash?: string,
    public departureDate?: number,
    public authorizingPersonHash?: string,
    public authorizingPersonName?: string,
    public requestMadeByHash?: string,
    public requestMadeByName?: string,
    public saleOfferDepartureReasonHash?: string,
    public saleOfferDepartureReasonName?: string,
    public observations?: string,
    public saleOfferDepartureSerialNumbers?: SaleOfferDepartureSerialNumber[],
    public duration?: number,
    public durationDate?: number
  ) { }

  clone() {
    return new SaleOfferDeparture(
      this.hash,
      this.departureDate,
      this.authorizingPersonHash,
      this.authorizingPersonName,
      this.requestMadeByHash,
      this.requestMadeByName,
      this.saleOfferDepartureReasonHash,
      this.saleOfferDepartureReasonName,
      this.observations,
      this.saleOfferDepartureSerialNumbers,
      this.duration,
      this.durationDate
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-offer-departure.ts